import { FormGroup, Label } from "reactstrap";
import __ from "src/utils/Translations";
import Select from "react-select";
import React, { useCallback, useMemo, useState } from "react";
import useFetchLocalizationsData from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api/useFetchLocalizationsData";
import { debounce } from "lodash";

interface ILocalizationsField {
  companyId: string;
  structureId: string;
  value: any;
  onChange: (value: any) => void;
  isEditable: boolean;
}

const LocalizationsField = ({
  companyId,
  structureId,
  value,
  onChange,
  isEditable,
}: ILocalizationsField) => {
  const [inputValue, setInputValue] = useState<string>("");

  const { data, isFetching, hasNextPage, fetchNextPage } =
    useFetchLocalizationsData(companyId, structureId, inputValue);

  const fetchedLocalizations = useMemo(
    () =>
      data?.pages.flatMap((page) =>
        page.content.map((loc) => ({
          value: loc.id,
          label: [loc.city, loc.streetAddress, loc.postalCode]
            .filter(Boolean)
            .join(", "),
        }))
      ) || [],
    [data]
  );

  const handleInputChange = useCallback(
    debounce((value) => {
      setInputValue(value);
    }, 1000),
    []
  );

  const handleScrollToBottom = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  return (
    <FormGroup>
      <Label for="localization">{__("Lokalizacja")}</Label>
      <Select
        id="localization"
        value={value}
        onChange={onChange}
        menuPlacement="auto"
        options={fetchedLocalizations}
        onInputChange={handleInputChange}
        onMenuScrollToBottom={handleScrollToBottom}
        placeholder={__("Wybierz")}
        noOptionsMessage={() => {
          if (isFetching) return __("Ładowanie...");
          return fetchedLocalizations.length > 0
            ? null
            : __("Brak wyników wyszukiwania");
        }}
        loadingMessage={() => __("Ładowanie...")}
        isClearable
        isLoading={isFetching}
        isDisabled={!isEditable}
      />
    </FormGroup>
  );
};

export default LocalizationsField;
